export function containsNodeText(range, node) {
  var treeWalker = document.createTreeWalker(
    node,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: function (node) {
        return NodeFilter.FILTER_ACCEPT;
      },
    },
    false,
  );
  var firstTextNode, lastTextNode, textNode;
  while ((textNode = treeWalker.nextNode())) {
    if (!firstTextNode) {
      firstTextNode = textNode;
    }
    lastTextNode = textNode;
  }
  var nodeRange = range.cloneRange();
  if (firstTextNode) {
    nodeRange.setStart(firstTextNode, 0);
    nodeRange.setEnd(lastTextNode, lastTextNode.length);
  } else {
    nodeRange.selectNodeContents(node);
  }
  return (
    range.compareBoundaryPoints(Range.START_TO_START, nodeRange) < 1 &&
    range.compareBoundaryPoints(Range.END_TO_END, nodeRange) > -1
  );
}
